import React from 'react';
import { Fab as MuiFab, makeStyles } from '@material-ui/core';
import { getIconComponent } from '../../utilities/icon_map';

const getStyles = makeStyles(() => ({
    fab: {
        position: 'fixed',
        right: 20,
        bottom: 20,
    }
}));

interface Props {
    icon: string;
    onClick: () => void;
}

const Fab: React.FC<Props> = props => {
    const styles = getStyles();
    return (
        <MuiFab
            className={styles.fab}
            onClick={props.onClick}
        >
           {getIconComponent(props.icon)}
        </MuiFab>
    );
};

export default Fab;